import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UserActivityDashboard from './UserActivityDashboard';

const UserActivityPage = (props) => {
	return <UserActivityDashboard {...props} />;
};

const mapStateToProps = (state) => ({
	user: state.user,
	org: state.org,
	appId: state.appConfig?.app?.dapp?._id || state.appConfig?.app?._id,
});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserActivityPage));
